<template>
  <div class="demo-tabs-style2">
    <Tabs type="card" closable v-model="CurrentPageid" @on-tab-remove="handleTabRemove">
      <TabPane label="小程序订单" icon="ios-home" :closable="false" name="小程序订单">
        <Home @HandleClick="HandleClick" :CurrentPageid="CurrentPageid"/>
      </TabPane>
      <TabPane :label="'(' + item.state + ')' + item.id + '(' + item.name + ')'" :name="item.id" icon="ios-calendar" v-for="item of tablist" :key="item.id">
        <Detail :OrderID="item.id" :State="item.state"/>
      </TabPane>
    </Tabs>
    <Voucher/>
  </div>
</template>

<script>
import Home from './component/OrderHome.vue'
import Detail from './component/OrderDetail.vue'
export default {
  name: 'AppletOrder',
  components: {
    Home,
    Detail
  },
  data () {
    return {
      tablist: [],
      CurrentPageid: ''
    }
  },
  methods: {
    // 点击办理 查看时回调
    HandleClick (OrderID, CustomerName, state) {
      if (this.tablist.length > 0) {
        let check = true // 判断是否已经存在该订单
        for (let i = 0; i < this.tablist.length; ++i) {
          if (this.tablist[i].id === OrderID) {
            check = false
            break
          }
        }
        if (check) {
          const info = {
            name: CustomerName,
            id: OrderID,
            state: state
          }
          this.tablist.push(info)
        }
      } else {
        const info = {
          name: CustomerName,
          id: OrderID,
          state: state
        }
        this.tablist.push(info)
      }
      this.CurrentPageid = OrderID
    },
    // 点击关闭时回调
    handleTabRemove (name) {
      for (let i = 0; i < this.tablist.length; ++i) {
        if (this.tablist[i].id === name) {
          this.tablist.splice(i, 1)
          break
        }
      }
    }
  }
}
</script>
<style scoped>
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab{
        border-radius: 0;
        background: #fff;
    }
    .demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active{
        border-top: 1px solid #3399ff;
    }
    .demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active:before{
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: #3399ff;
        position: absolute;
        top: 0;
        left: 0;
    }
</style>
